import React, { Fragment, useEffect, useRef } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getMagicPotDashBoard } from '../../../helper/BackendHelper';
import Pagination from "react-js-pagination";
import { MagicPotsDonationList, MagicPotsDonationListByPage } from "../../../store/thunk/MagicpotThunk";
import { MagicpotIsLoading, MagicPotDonationList } from "../../../store/selectors/MagicpotSelector";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import PageLoader from "../../layouts/PageLoader";
import { curencyFormaterNarmal } from '../../../helper/formater';
import DateRangePicker from "react-bootstrap-daterangepicker";
import $ from 'jquery';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';

const MagicPotDashboard = ({ magicpotdonationlist, isLoading }) => {
   const dispatch = useDispatch();
   const [searchQuary, setSearchQuary] = useState("");
   const [dateQuary, setDateQuary] = useState();
   const [statusQuary, setStatusQuary] = useState();
   const [dashBoardData, setMagiDashBoardData] = useState();
   // const [isdataLoading, setIsLoading] = useState(true);
   const [showListing,setShowListing] = useState(0);
   const inputContainerRef = useRef(null);

   useEffect(() => {
      // setIsLoading(true);
      getMagicPotDashBoard()
         .then((res) => {
            if (res?.status === 'success') {
               setMagiDashBoardData(res?.data);
            }
         })
         .catch((err) => {
            console.error("Failed to fetch dashboard data", err);
         })
         // .finally(() => setIsLoading(false));
   }, []);

   useEffect(() => {
      if (dateQuary && statusQuary && searchQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1, dateQuary, statusQuary }))
      } else if (dateQuary && statusQuary) {
         dispatch(MagicPotsDonationListByPage({ pageNumber: 1, dateQuary, statusQuary }))
      } else if (dateQuary && searchQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary,pageNumber: 1, dateQuary }))
      } else if (searchQuary && statusQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1, statusQuary }))
      } else if (statusQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1, statusQuary }))
      } else if (dateQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1, dateQuary }))
      }else if (searchQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1, dateQuary }))
      }
      else {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1 }))
      }
   }, [searchQuary, dateQuary, statusQuary])

   const clearFilter = () => {
      setSearchQuary("");
      const inputEl = inputContainerRef.current?.querySelector('input');
      if (inputEl) {
         const picker = $(inputEl).data('daterangepicker');
         if (picker) {
         picker.setStartDate(moment());
         picker.setEndDate(moment());
         picker.element.val('');
         }
      }
      setDateQuary("")
      setStatusQuary('')
   }

   const getmagicPotAmountList = (e) =>{
      e.preventDefault();
      if (!magicpotdonationlist || magicpotdonationlist.length === 0) {
         dispatch(MagicPotsDonationList());
      }
      setShowListing(1)
   }

   return (
      <Fragment>
         <PageLoader isLoading={isLoading} >
            {/* <PageTitle activeMenu="Donations List" motherMenu="Donetions" /> */}
            <div className="row">
               <div className="col-xl-12">
                  <div className="row">
                     <div className="col-xl-4 col-sm-6">
                        <div className="card overflow-hidden">
                           <Link to={`/magicpot-dashboard`}>
                              <div className="card-header border-0" onClick={(e)=>{getmagicPotAmountList(e)}}>
                                 <div className="d-flex">
                                    <span className="mt-1">
                                       <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fillRule="evenodd" clipRule="evenodd" d="M17.812 48.64L11.2 53.6C10.594 54.054 9.78401 54.128 9.10602 53.788C8.42802 53.45 8.00002 52.758 8.00002 52V16C8.00002 14.896 8.89602 14 10 14H38C39.104 14 40 14.896 40 16V52C40 52.758 39.572 53.45 38.894 53.788C38.216 54.128 37.406 54.054 36.8 53.6L30.188 48.64L25.414 53.414C24.634 54.196 23.366 54.196 22.586 53.414L17.812 48.64ZM36 48V18H12V48L16.8 44.4C17.596 43.802 18.71 43.882 19.414 44.586L24 49.172L28.586 44.586C29.29 43.882 30.404 43.802 31.2 44.4L36 48ZM22 34H26C27.104 34 28 33.104 28 32C28 30.896 27.104 30 26 30H22C20.896 30 20 30.896 20 32C20 33.104 20.896 34 22 34ZM18 26H30C31.104 26 32 25.104 32 24C32 22.896 31.104 22 30 22H18C16.896 22 16 22.896 16 24C16 25.104 16.896 26 18 26Z" fill="#44814E" />
                                          <circle cx="43.5" cy="14.5" r="12.5" fill="#09BD3C" stroke="white" strokeWidth="4" />
                                       </svg>
                                    </span>
                                    <div className="invoices">
                                       <h4>{curencyFormaterNarmal.format(dashBoardData?.donationRaised)}</h4>
                                       <span>Magic Pot amount </span>
                                    </div>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="col-xl-4 col-sm-6">
                        <div className="card overflow-hidden">
                           <Link to={`/magicpot-event-list`}>
                              <div className="card-header border-0">
                                 <div className="d-flex">
                                    <span className="mt-1">
                                       <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fillRule="evenodd" clipRule="evenodd" d="M17.812 48.64L11.2 53.6C10.594 54.054 9.78401 54.128 9.10602 53.788C8.42802 53.45 8.00002 52.758 8.00002 52V16C8.00002 14.896 8.89602 14 10 14H38C39.104 14 40 14.896 40 16V52C40 52.758 39.572 53.45 38.894 53.788C38.216 54.128 37.406 54.054 36.8 53.6L30.188 48.64L25.414 53.414C24.634 54.196 23.366 54.196 22.586 53.414L17.812 48.64ZM36 48V18H12V48L16.8 44.4C17.596 43.802 18.71 43.882 19.414 44.586L24 49.172L28.586 44.586C29.29 43.882 30.404 43.802 31.2 44.4L36 48ZM22 34H26C27.104 34 28 33.104 28 32C28 30.896 27.104 30 26 30H22C20.896 30 20 30.896 20 32C20 33.104 20.896 34 22 34ZM18 26H30C31.104 26 32 25.104 32 24C32 22.896 31.104 22 30 22H18C16.896 22 16 22.896 16 24C16 25.104 16.896 26 18 26Z" fill="#44814E" />
                                          <circle cx="43.5" cy="14.5" r="12.5" fill="#FD5353" stroke="white" strokeWidth="4" />
                                       </svg>
                                    </span>
                                    <div className="invoices">
                                       <h4>{curencyFormaterNarmal.format(dashBoardData?.donationPaid)}</h4>
                                       <span>Amount for events</span>
                                    </div>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="col-xl-4 col-sm-6">
                        <div className="card overflow-hidden">
                           <Link to={`/magicpot-dashboard`}>
                              <div className="card-header border-0">
                                 <div className="d-flex">
                                    <span className="mt-1">
                                       <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fillRule="evenodd" clipRule="evenodd" d="M17.812 48.64L11.2 53.6C10.594 54.054 9.784 54.128 9.106 53.788C8.428 53.45 8 52.758 8 52V16C8 14.896 8.896 14 10 14H38C39.104 14 40 14.896 40 16V52C40 52.758 39.572 53.45 38.894 53.788C38.216 54.128 37.406 54.054 36.8 53.6L30.188 48.64L25.414 53.414C24.634 54.196 23.366 54.196 22.586 53.414L17.812 48.64ZM36 48V18H12V48L16.8 44.4C17.596 43.802 18.71 43.882 19.414 44.586L24 49.172L28.586 44.586C29.29 43.882 30.404 43.802 31.2 44.4L36 48ZM22 34H26C27.104 34 28 33.104 28 32C28 30.896 27.104 30 26 30H22C20.896 30 20 30.896 20 32C20 33.104 20.896 34 22 34ZM18 26H30C31.104 26 32 25.104 32 24C32 22.896 31.104 22 30 22H18C16.896 22 16 22.896 16 24C16 25.104 16.896 26 18 26Z" fill="#44814E" />
                                          <circle cx="43.5" cy="14.5" r="12.5" fill="#FFAA2B" stroke="white" strokeWidth="4" />
                                       </svg>
                                    </span>
                                    <div className="invoices">
                                       <h4>{curencyFormaterNarmal.format(dashBoardData?.donationBalance)}</h4>
                                       <span>Balance amount</span>
                                    </div>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
               {(showListing == 1)?<div className="col-lg-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="row align-items-center">
                           <div className="col-lg-4">
                              <div className="input-group search-area">
                                 <input type="text"
                                    className={`form-control active`}
                                    placeholder=" Search by Name"
                                    onChange={(e) => setSearchQuary(e.currentTarget.value)}
                                    value={searchQuary}
                                 />
                                 <span className="input-group-text" >
                                    <i className="flaticon-381-search-2"></i>
                                 </span>
                              </div>
                         </div>
                           <div className="col-lg-3">
                              <div className="input-group" ref={inputContainerRef}>
                                 <DateRangePicker
                                    onCallback={(start, end, label) => {
                                       setDateQuary({
                                          fromDate: start?.format('YYYY-MM-DD'),
                                          toDate: end?.format('YYYY-MM-DD')
                                       })
                                    }}
                                    initialSettings={{
                                       autoUpdateInput: false,
                                       locale: {
                                          cancelLabel: 'Clear',
                                       },
                                    }}
                                    onApply={(event, picker) => {
                                       picker.element.val(
                                          picker.startDate.format('MM/DD/YYYY') +
                                          ' - ' +
                                          picker.endDate.format('MM/DD/YYYY')
                                       );
                                    }}
                                    onCancel={(event, picker) => {
                                       picker.element.val('');
                                       setDateQuary(null);
                                    }}
                                 >
                                    <input type="text" className="form-control input-daterange-timepicker" placeholder="Select Date" />
                                 </DateRangePicker>
                              </div>
                           </div>
                           <div className="col-lg-2">
                              <div className="input-group">

                                 <Button onClick={clearFilter}>Clear Filter</Button>
                              </div>
                           </div>
                        </div>
                        <br />
                        <div className="table-responsive">
                        <table className="table mb-0 table-striped">
                              <thead>
                                 <tr>
                                    <th>Name</th>
                                    <th>Amount</th>
                                    <th>Path of Payment</th>
                                    <th>Date & Time</th>
                                    <th>Payment method</th>
                                    <th></th>
                                 </tr>
                              </thead>
                              <tbody id="MagicPotDonationList">
                                 {
                                    magicpotdonationlist?.data?.map((donlist, index) => {
                                       let path = donlist?.path ? donlist?.path : (donlist?.pledged_meal ? "MILESTONES" : donlist?.connect ? "CONNECT" : "MAGIC POT");
                                       return (
                                          <tr className="btn-reveal-trigger" key={index}>
                                             <td className="py-3">
                                                <Link to={`/donation-details/${donlist?.id}`}>
                                                   <div className="media d-flex align-items-center">
                                                      <div className="media-body">
                                                         <h5 className="mb-0 fs--1">
                                                            {donlist?.donate_by?.name}
                                                         </h5>
                                                      </div>
                                                   </div>
                                                </Link>
                                             </td>
                                             <td className="py-2">
                                                ₹{donlist?.amount}
                                             </td>
                                             <td className="py-2">
                                                {donlist?.path !== null && donlist?.path !== undefined && donlist?.magic_pot !== null ? donlist?.path : path}

                                             </td>
                                             <td className="py-2 ">

                                                {format(new Date(donlist?.created_at), "dd-MM-yyyy,  p")}
                                             </td>
                                             <td className="py-2 ">
                                                {donlist?.paymentmethod?.name}
                                             </td>
                                             <td className="py-2">
                                                <Dropdown>
                                                   <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
                                                      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                         <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24"></rect>
                                                            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                                         </g>
                                                      </svg>
                                                   </Dropdown.Toggle>
                                                   <Dropdown.Menu>
                                                      <Dropdown.Item ><Link to={`/donation-details/${donlist?.id}`} className="d-link">Process </Link></Dropdown.Item>
                                                   </Dropdown.Menu>
                                                </Dropdown>
                                             </td>
                                          </tr>
                                       )
                                    })
                                 }
                              </tbody>
                           </table>
                        </div>
                        <br />
                        <div>
                           <Pagination
                              activePage={magicpotdonationlist?.current_page ? magicpotdonationlist?.current_page : 0}
                              itemsCountPerPage={magicpotdonationlist?.per_page ? magicpotdonationlist?.per_page : 0}
                              totalItemsCount={magicpotdonationlist?.total ? magicpotdonationlist?.total : 0}
                              onChange={(pageNumber) => {
                                 dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber, date: dateQuary != null ? format(new Date(dateQuary), "yyyy-MM-dd") : "" }))
                              }}
                              pageRangeDisplayed={8}
                              itemClass="page-item"
                              linkClass="page-link"
                              firstPageText="First Page"
                              lastPageText="Last Page"
                           />
                        </div>
                     </div>
                  </div>
               </div>:''}
            </div>
         </PageLoader>
      </Fragment>
   );
};

const mapStateToProps = (state) => {
   return {
      magicpotdonationlist: MagicPotDonationList(state),
      isLoading: MagicpotIsLoading(state)
   };
};

export default connect(mapStateToProps)(MagicPotDashboard);


